// 클립보드 복사
export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    alert('클립보드에 복사되었습니다.');
  });
};

// D-day 함수
export function getDaysUntilDday(targetDate) {
  const today = new Date();
  const dDay = new Date(targetDate);

  // 시간 차이 계산
  const timeDiff = dDay.getTime() - today.getTime();
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  let status;
  if (daysLeft > 0) {
    status = 'upcoming'; // D-Day가 아직 남음
  } else if (daysLeft === 0) {
    status = 'today'; // 오늘이 D-Day
  } else {
    status = 'past'; // D-Day가 지남
  }

  return { daysLeft, status };
}

export const getImageList = () => {
  const imageContext = require.context(
    '../assets/images/gallery',
    false,
    /gallery_\d+\.png$/,
  );

  const imageList = imageContext.keys().map((key) => {
    const match = key.match(/gallery_(\d+)\.png$/);
    const id = match ? parseInt(match[1]) : 0;

    return {
      id,
      image: imageContext(key),
      path: key,
    };
  });

  return imageList.sort((a, b) => a.id - b.id);
};

// 날짜 변환 함수
export const formatDate = (timestamp) => {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  // const hours = String(date.getHours()).padStart(2, '0');
  // const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}년 ${month}월 ${day}일`;
};
